import React from 'react';
import { useTranslation } from 'react-i18next';
import SearchDialog from './SearchDialog';

const FactorySearchDialog = ({ open, onClose, onSelect, initialSearchResult, factories = [], loading = false }) => {
    const { t } = useTranslation();

    const columns = [
        { key: 'delivery_name', label: t('factories.fields.name') },
        { key: 'partner_name', label: t('common.searchFields.customer') },
        { key: 'delivery_shipping_mark', label: t('factories.fields.shippingMark') },
        { key: 'address', label: t('factories.fields.address') }
    ];

    const renderRow = (factory, StyledTableRow, BodyCell, handleRowClick) => (
        <StyledTableRow
            key={factory.delivery_id}
            onClick={() => handleRowClick(factory)}
            aria-label={`${factory.delivery_name} (${factory.partner_name || '-'})`}
        >
            <BodyCell>{factory.delivery_name || '-'}</BodyCell>
            <BodyCell>{factory.partner_name || '-'}</BodyCell>
            <BodyCell>{factory.delivery_shipping_mark || '-'}</BodyCell>
            <BodyCell>{factory.address || '-'}</BodyCell>
        </StyledTableRow>
    );

    const customFilter = (data, searchTerm) => {
        const searchTermLower = searchTerm.toLowerCase();
        return data.filter(factory => {
            const deliveryName = factory.delivery_name?.toLowerCase() || '';
            const partnerName = factory.partner_name?.toLowerCase() || '';
            const address = factory.address?.toLowerCase() || '';
            return deliveryName.includes(searchTermLower) || 
                   partnerName.includes(searchTermLower) || 
                   address.includes(searchTermLower);
        });
    };

    return (
        <SearchDialog
            open={open}
            onClose={onClose}
            onSelect={onSelect}
            initialSearchResult={initialSearchResult}
            allData={factories}
            title={t('common.searchFields.factory')}
            placeholder={t('common.search')}
            searchKeys={['delivery_name', 'partner_name', 'address']}
            columns={columns}
            renderRow={renderRow}
            customFilter={customFilter}
            listTitle={t('factories.list.title')}
            isLoading={loading}
        />
    );
};

export default FactorySearchDialog;